<template>
    <div>
        <span>{{ placeholder | trans }}</span>
        <v-select
            :searchable="false"
            :options="options"
            :onChange="selected"
            :label="label"
        >
            <template slot="option" slot-scope="option">
                {{ option.label }}
            </template>
        </v-select>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import { hasIn } from 'ramda';

export default {
    name: 'gl-select',
    props: {
        placeholder: {
            type: String,
            required: true
        },
        options: {
            type: Array,
            required: true
        }
    },
    methods: {
        selected(val) {
            let value = val;
            if (hasIn('value', val)) {
                value = val.value;
            }
            this.$emit('select', value);
        }
    },
    components: {
        vSelect
    }
};
</script>



// WEBPACK FOOTER //
// src/components/Options.vue